export class CreateNewTurnRequest {
    static Message = 'CreateNewTurnRequest';
}
